function isMobile() {
    if (window.innerWidth < 600) {
        return true;
    }
    return false;
}

export { isMobile }